// Replace with generated Relay type when My Work is converted to TS
type TaskNode = {
	node?: {
		assignedPersons?: [
			{
				id?: string;
			}
		];
	};
};

export function taskAssignedToSelectedPersonPredicate(task: TaskNode, selectedPersonId: string): boolean {
	return !!task?.node?.assignedPersons?.map(assignedPerson => assignedPerson?.id)?.includes(selectedPersonId);
}
